import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export type QueryCardTriggerDot = 'verde' | 'amarelo' | 'vermelho';

export interface QueryCardTriggerProps {
  onClick: () => void;
  label?: string;
  hint?: string;
  padded?: boolean;
  // `false` (padrao): `hint` fica a direita, na mesma linha do label.
  // `true`: `hint` vira subtitulo sob o label, para resumos longos.
  stacked?: boolean;
  // Semaforo opcional entre o hint e o chevron.
  dot?: QueryCardTriggerDot;
  // Linha divisoria acima do trigger — usado quando ele vem logo apos
  // outro bloco de conteudo dentro do mesmo card (ex.: chips do cabecalho).
  bordaSuperior?: boolean;
}

export default function QueryCardTrigger({
  onClick, label = 'Painel de controle', hint, padded = true, stacked = false, dot,
  bordaSuperior = false,
}: QueryCardTriggerProps) {
  return (
    <button
      type="button"
      className={`query-card-trigger${padded ? '' : ' query-card-trigger-bare'}${bordaSuperior ? ' query-card-trigger-borda-superior' : ''}`}
      onClick={onClick}
    >
      <svg
        className="query-card-trigger-icon"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke={cssVar('text-strong')}
        strokeWidth={1.8}
        strokeLinecap="round"
      >
        <path d="M4 6h9" />
        <circle cx="17" cy="6" r="2.2" />
        <path d="M20 12h-9" />
        <circle cx="7" cy="12" r="2.2" />
        <path d="M4 18h9" />
        <circle cx="17" cy="18" r="2.2" />
      </svg>
      {stacked ? (
        <span className="query-card-trigger-stack">
          <span className="query-card-trigger-label">{label}</span>
          {hint && <span className="query-card-trigger-hint">{hint}</span>}
        </span>
      ) : (
        <>
          <span className="query-card-trigger-label">{label}</span>
          {hint && <span className="query-card-trigger-hint">{hint}</span>}
        </>
      )}
      {dot && <span className={`query-card-trigger-dot is-${dot}`} />}
      <Icon iconType="right_arrow" color={cssVar('text-disabled')} size="small" />
    </button>
  );
}
